{
  "CONTACT_PANEL": {
    "NOT_AVAILABLE": "לא זמין",
    "EMAIL_ADDRESS": "כתובת מייל",
    "PHONE_NUMBER": "מספר טלפון",
    "IDENTIFIER": "מזהה",
    "COPY_SUCCESSFUL": "הועתק ללוח בהצלחה",
    "COMPANY": "חברה",
    "LOCATION": "מיקום",
    "BROWSER_LANGUAGE": "שפת דפדפן",
    "CONVERSATION_TITLE": "פרטי שיחה",
    "VIEW_PROFILE": "הצג פרופיל",
    "BROWSER": "דפדפן",
    "OS": "מערכת הפעלה",
    "INITIATED_FROM": "נוצר מ",
    "INITIATED_AT": "נוצר ב",
    "IP_ADDRESS": "כתובת IP",
    "CREATED_AT_LABEL": "נוצר",
    "NEW_MESSAGE": "הודעה חדשה",
    "CALL": "התקשר",
    "CALL_INITIATED": "Calling the contact…",
    "CALL_FAILED": "Unable to start the call. Please try again.",
    "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
    "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
    "CLICK_TO_EDIT": "Click to edit",
    "VOICE_INBOX_PICKER": {
      "TITLE": "בחר תיבת דואר קולי"
    },
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "לא קיימות שיחות קודמות המשויכות לאיש קשר זה.",
      "TITLE": "שיחות קודמות"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "תגיות אנשי קשר",
        "ERROR": "לא ניתן לעדכן תוויות"
      },
      "CONVERSATION": {
        "TITLE": "תוויות שיחה",
        "ADD_BUTTON": "הוסף תוויות"
      },
      "LABEL_SELECT": {
        "TITLE": "הוסף תוויות",
        "PLACEHOLDER": "חפש תוויות",
        "NO_RESULT": "לא נמצאו תוויות",
        "CREATE_LABEL": "צור תווית חדשה"
      }
    },
    "MERGE_CONTACT": "מזג אנשי קשר",
    "CONTACT_ACTIONS": "פעולות אנשי קשר",
    "MUTE_CONTACT": "חסום איש קשר",
    "UNMUTE_CONTACT": "בטל חסימת איש קשר",
    "MUTED_SUCCESS": "איש הקשר נחסם בהצלחה. לא תקבל הודעה על שיחות עתידיות.",
    "UNMUTED_SUCCESS": "איש הקשר נבטל חסימה בהצלחה.",
    "SEND_TRANSCRIPT": "שלח תמלול",
    "EDIT_LABEL": "ערוך",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "שדות מותאמים אישית",
      "CONTACT_LABELS": "תגיות אנשי קשר",
      "PREVIOUS_CONVERSATIONS": "שיחות קודמות",
      "NO_RECORDS_FOUND": "לא נמצאו מאפיינים"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "ערוך איש קשר",
    "TITLE": "ערוך איש קשר",
    "DESC": "ערוך את פרטי איש הקשר"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "מחק איש קשר",
    "TITLE": "מחק איש קשר",
    "DESC": "מחק את פרטים של איש הקשר",
    "CONFIRM": {
      "TITLE": "אשר מחיקה",
      "MESSAGE": "האם אתה בטוח שברצונך למחוק ",
      "YES": "כן, מחק",
      "NO": "לא, השאר"
    },
    "API": {
      "SUCCESS_MESSAGE": "איש הקשר נמחק בהצלחה",
      "ERROR_MESSAGE": "לא ניתן היה למחוק איש קשר. בבקשה נסה שוב מאוחר יותר."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "שלח",
      "CANCEL": "ביטול",
      "AVATAR": {
        "LABEL": "צור קשר עם אווטאר"
      },
      "NAME": {
        "PLACEHOLDER": "הזן את שמו המלא של איש הקשר",
        "LABEL": "שם מלא"
      },
      "BIO": {
        "PLACEHOLDER": "הזן את הביוגרפיה של איש הקשר",
        "LABEL": "ביוגרפיה"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "הזן את כתובת האימייל של איש הקשר",
        "LABEL": "כתובת מייל",
        "DUPLICATE": "כתובת דוא\"ל זו נמצאת בשימוש עבור איש קשר אחר.",
        "ERROR": "בבקשה הכנס כתוכת אימייל תקינה."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "הזן את מספר הטלפון של איש הקשר",
        "LABEL": "מספר טלפון",
        "HELP": "מספר הטלפון צריך להיות בפורמט E.164, למשל: +1415555555 [+][קוד מדינה][אזור חיוג][מספר טלפון מקומי]",
        "ERROR": "מספר הטלפון צריך להיות ריק או בפורמט E.164",
        "DIAL_CODE_ERROR": "נא בחר קוד מדינה מהרשימה",
        "DUPLICATE": "מספר טלפון זה נמצאת בשימוש עבור איש קשר אחר."
      },
      "LOCATION": {
        "PLACEHOLDER": "הזן את המיקום של איש הקשר",
        "LABEL": "מיקום"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "הזן את שם החברה",
        "LABEL": "שם החברה"
      },
      "COUNTRY": {
        "PLACEHOLDER": "הזן את שם המדינה",
        "LABEL": "שם המדינה",
        "SELECT_PLACEHOLDER": "בחר",
        "REMOVE": "הסר",
        "SELECT_COUNTRY": "בחר מדינה"
      },
      "CITY": {
        "PLACEHOLDER": "הזן את שם העיר",
        "LABEL": "שם העיר"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "הזן את שם המשתמש בפייסבוק",
          "LABEL": "פייסבוק"
        },
        "TWITTER": {
          "PLACEHOLDER": "הזן את שם המשתמש בטוויטר",
          "LABEL": "טוויטר"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "הזן את שם המשתמש בלינקדאין",
          "LABEL": "לינקדאין"
        },
        "GITHUB": {
          "PLACEHOLDER": "הזן את שם המשתמש של Github",
          "LABEL": "Github"
        }
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "תמונת פרופיל נמחקה",
        "ERROR_MESSAGE": "מחיקת התמונה נכשלה. נסה שנית מאוחר יותר."
      }
    },
    "SUCCESS_MESSAGE": "איש הקשר נשמר בהצלחה",
    "ERROR_MESSAGE": "היתה שגיאה, בקשה נסה שוב"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "התחל שיחה",
    "TITLE": "שיחה חדשה",
    "DESC": "התחל שיחה חדשה על ידי שליחת הודעה חדשה.",
    "NO_INBOX": "לא ניתן היה למצוא תיבת דואר נכנס כדי ליזום שיחה חדשה עם איש הקשר הזה.",
    "FORM": {
      "TO": {
        "LABEL": "אל"
      },
      "INBOX": {
        "LABEL": "תיבת הדואר הנכנס",
        "PLACEHOLDER": "בחר תיבת מקור",
        "ERROR": "בחר תיבת דואר נכנס"
      },
      "SUBJECT": {
        "LABEL": "נושא",
        "PLACEHOLDER": "נושא",
        "ERROR": "הנושא לא יכול להיות ריק"
      },
      "MESSAGE": {
        "LABEL": "הודעה",
        "PLACEHOLDER": "כתוב את הודעתך כאן",
        "ERROR": "ההודעה לא יכולה להיות ריקה"
      },
      "ATTACHMENTS": {
        "SELECT": "בחר קבצים",
        "HELP_TEXT": "גרור ושחרר קבצים כאן או בחר קבצים מצורפים"
      },
      "SUBMIT": "שלח הודעה",
      "CANCEL": "ביטול",
      "SUCCESS_MESSAGE": "הודעה נשלחה!",
      "GO_TO_CONVERSATION": "צפה",
      "ERROR_MESSAGE": "לא ניתן לשלוח! נסה שוב"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "פרופילים חברתיים"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "הוסף מאפיין מותאם אישית",
    "COPY_SUCCESSFUL": "הועתק ללוח בהצלחה",
    "SHOW_MORE": "הצג את כל התכונות",
    "SHOW_LESS": "הצג פחות תכונות",
    "ACTIONS": {
      "COPY": "העתק מאפיין",
      "DELETE": "מחק מאפיין",
      "EDIT": "ערוך מאפיין"
    },
    "ADD": {
      "TITLE": "צור מאפיין מותאם אישית",
      "DESC": "הוסף מידע מותאם אישית לאיש קשר זה."
    },
    "FORM": {
      "CREATE": "הוסף מאפיין",
      "CANCEL": "ביטול",
      "NAME": {
        "LABEL": "שם מאפיין מותאם אישית",
        "PLACEHOLDER": "למשל: מזהה shopify",
        "ERROR": "שם מאפיין מותאם אישית לא חוקי"
      },
      "VALUE": {
        "LABEL": "ערך מאפיין",
        "PLACEHOLDER": "למשל: 11901 "
      },
      "ADD": {
        "TITLE": "צור מאפיין חדש ",
        "SUCCESS": "מאפיין נוסף בהצלחה",
        "ERROR": "לא ניתן היה ליצור מאפיין, אנא נסה שוב מאוחר יותר"
      },
      "UPDATE": {
        "SUCCESS": "המאפיין עודכן בהצלחה",
        "ERROR": "לא ניתן לעדכן את המאפיין. בבקשה נסה שוב מאוחר יותר"
      },
      "DELETE": {
        "SUCCESS": "המאפיין נמחק בהצלחה",
        "ERROR": "לא ניתן למחוק מאפיין. בבקשה נסה שוב מאוחר יותר"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "הוסף מאפיין",
        "PLACEHOLDER": "חפש מאפיין",
        "NO_RESULT": "לא נמצאו מאפיינים"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "בחר ערך",
          "SEARCH_INPUT_PLACEHOLDER": "חפש ערך",
          "NO_RESULT": "לא נמצאו תוצאות"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "נדרש ערך חוקי",
      "INVALID_URL": "כתובת אתר לא חוקית",
      "INVALID_INPUT": "קלט לא חוקי"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "מזג אנשי קשר",
    "DESCRIPTION": "מיזוג אנשי קשר כדי לשלב שני פרופילים לאחד, כולל כל התכונות והשיחות. במקרה של התנגשות, התכונות של איש הקשר הראשי יקבלו עדיפות.",
    "PRIMARY": {
      "TITLE": "איש קשר ראשי",
      "HELP_LABEL": "להימחק"
    },
    "PARENT": {
      "TITLE": "צור קשר למיזוג",
      "PLACEHOLDER": "חפש איש קשר",
      "HELP_LABEL": "להישמר"
    },
    "SUMMARY": {
      "TITLE": "סיכום",
      "DELETE_WARNING": "איש הקשר של <strong>{primaryContactName}</strong> יימחק.",
      "ATTRIBUTE_WARNING": "פרטי הקשר של <strong>{primaryContactName}</strong> יועתקו אל <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "משהו השתבש. אנא נסה שוב מאוחר יותר."
    },
    "FORM": {
      "SUBMIT": " מזג אנשי קשר",
      "CANCEL": "ביטול",
      "CHILD_CONTACT": {
        "ERROR": "בחר איש קשר צאצא למזג"
      },
      "SUCCESS_MESSAGE": "איש הקשר מוזג בהצלחה",
      "ERROR_MESSAGE": "לא ניתן למזג אנשי קשר, נסה שוב!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(מזהה: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "איש קשר",
      "SEARCH_TITLE": "חפש אנשי קשר",
      "ACTIVE_TITLE": "אנשי קשר פעילים",
      "SEARCH_PLACEHOLDER": "חיפוש...",
      "MESSAGE_BUTTON": "הודעה",
      "SEND_MESSAGE": "שלח הודעה",
      "BLOCK_CONTACT": "חסום איש קשר",
      "UNBLOCK_CONTACT": "בטל חסימת איש קשר",
      "BREADCRUMB": {
        "CONTACTS": "איש קשר"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "הוסף איש קשר",
          "EXPORT_CONTACT": "ייצא אנשי קשר",
          "IMPORT_CONTACT": "ייבא אנשי קשר",
          "SAVE_CONTACT": "שמור איש קשר",
          "EMAIL_ADDRESS_DUPLICATE": "כתובת דוא\"ל זו נמצאת בשימוש עבור איש קשר אחר.",
          "PHONE_NUMBER_DUPLICATE": "מספר טלפון זה נמצאת בשימוש עבור איש קשר אחר.",
          "SUCCESS_MESSAGE": "איש הקשר נשמר בהצלחה",
          "ERROR_MESSAGE": "לא ניתן לשמור איש קשר. אנא נסה שוב מאוחר יותר."
        },
        "BLOCK_SUCCESS_MESSAGE": "איש קשר זה נחסם בהצלחה",
        "BLOCK_ERROR_MESSAGE": "לא ניתן לחסום איש קשר. אנא נסה שוב מאוחר יותר.",
        "UNBLOCK_SUCCESS_MESSAGE": "איש קשר זה בוטל חסימה בהצלחה",
        "UNBLOCK_ERROR_MESSAGE": "לא ניתן לבטל חסימת איש קשר. אנא נסה שוב מאוחר יותר.",
        "IMPORT_CONTACT": {
          "TITLE": "ייבא אנשי קשר",
          "DESCRIPTION": "ייבא אנשי קשר באמצעות קובץ CSV.",
          "DOWNLOAD_LABEL": "הורד קובץ csv לדוגמה.",
          "LABEL": "קובץ CSV:",
          "CHOOSE_FILE": "בחר קובץ",
          "CHANGE": "שינוי",
          "CANCEL": "ביטול",
          "IMPORT": "ייבוא",
          "SUCCESS_MESSAGE": "תקבלו התראה במייל כשהייבוא יסתיים.",
          "ERROR_MESSAGE": "היתה שגיאה, בקשה נסה שוב"
        },
        "EXPORT_CONTACT": {
          "TITLE": "ייצא אנשי קשר",
          "DESCRIPTION": "ייצא במהירות קובץ CSV עם פרטים מקיפים על אנשי הקשר שלך",
          "CONFIRM": "ייצא",
          "SUCCESS_MESSAGE": "הייצוא מתבצע, תקבל הודעה בדוא\"ל כאשר קובץ הייצוא יהיה מוכן להורדה.",
          "ERROR_MESSAGE": "היתה שגיאה, בקשה נסה שוב"
        },
        "SORT_BY": {
          "LABEL": "מיין לפי",
          "OPTIONS": {
            "NAME": "שם",
            "EMAIL": "אימייל",
            "PHONE_NUMBER": "מספר טלפון",
            "COMPANY": "חברה",
            "COUNTRY": "מדינה",
            "CITY": "עיר",
            "LAST_ACTIVITY": "פעילות אחרונה",
            "CREATED_AT": "נוצר בזמן"
          }
        },
        "ORDER": {
          "LABEL": "סדר",
          "OPTIONS": {
            "ASCENDING": "עולה",
            "DESCENDING": "יורד"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "האם אתה רוצה לשמור את המסנן הזה?",
            "CONFIRM": "שמור מסנן",
            "LABEL": "שם",
            "PLACEHOLDER": "הזן את שם המסנן",
            "ERROR": "הזן שם חוקי",
            "SUCCESS_MESSAGE": "המסנן נשמר בהצלחה",
            "ERROR_MESSAGE": "לא ניתן לשמור את המסנן. אנא נסה שוב מאוחר יותר."
          },
          "DELETE_SEGMENT": {
            "TITLE": "אשר מחיקה",
            "DESCRIPTION": "האם אתה בטוח שברצונך למחוק מסנן זה?",
            "CONFIRM": "כן, מחק",
            "CANCEL": "לא, ביטול",
            "SUCCESS_MESSAGE": "המסנן נמחק בהצלחה",
            "ERROR_MESSAGE": "לא ניתן למחוק את המסנן. אנא נסה שוב מאוחר יותר."
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Showing {startItem} - {endItem} of {totalItems} contacts"
    },
    "FILTER": {
      "NAME": "שם",
      "EMAIL": "אימייל",
      "PHONE_NUMBER": "מספר טלפון",
      "IDENTIFIER": "מזהה",
      "COUNTRY": "מדינה",
      "CITY": "עיר",
      "COMPANY": "חברה",
      "CREATED_AT": "נוצר בזמן",
      "LAST_ACTIVITY": "פעילות אחרונה",
      "REFERER_LINK": "קישור מפנה",
      "BLOCKED": "חסום",
      "BLOCKED_TRUE": "נכון",
      "BLOCKED_FALSE": "לא נכון",
      "BUTTONS": {
        "CLEAR_FILTERS": "נקה מסננים",
        "UPDATE_SEGMENT": "עדכן מקטע",
        "APPLY_FILTERS": "שמור סננים",
        "ADD_FILTER": "הוסף מסנן"
      },
      "TITLE": "סינון אנשי קשר",
      "EDIT_SEGMENT": "ערוך מקטע",
      "SEGMENT": {
        "LABEL": "שם המקטע",
        "INPUT_PLACEHOLDER": "הזן את שם המקטע"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} מסננים נוספים",
        "CLEAR_FILTERS": "נקה מסננים"
      }
    },
    "CARD": {
      "OF": "מתוך",
      "VIEW_DETAILS": "הצג פרטים",
      "EDIT_DETAILS_FORM": {
        "TITLE": "ערוך את פרטי איש הקשר",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "הזן שם פרטי"
          },
          "LAST_NAME": {
            "PLACEHOLDER": "הזן שם משפחה"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "הזן כתובת דוא\"ל",
            "DUPLICATE": "כתובת דוא\"ל זו נמצאת בשימוש עבור איש קשר אחר."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "הזן מספר טלפון",
            "DUPLICATE": "מספר טלפון זה נמצאת בשימוש עבור איש קשר אחר."
          },
          "CITY": {
            "PLACEHOLDER": "הזן את שם העיר"
          },
          "COUNTRY": {
            "PLACEHOLDER": "בחר מדינה"
          },
          "BIO": {
            "PLACEHOLDER": "הזן ביוגרפיה"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "הזן את שם החברה"
          }
        },
        "UPDATE_BUTTON": "עדכן איש קשר",
        "SUCCESS_MESSAGE": "איש קשר עודכן בהצלחה",
        "ERROR_MESSAGE": "לא ניתן לעדכן איש קשר. אנא נסה שוב מאוחר יותר."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "ערוך קישורים חברתיים",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "הוסף פייסבוק"
          },
          "GITHUB": {
            "PLACEHOLDER": "הוסף Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "הוסף אינסטגרם"
          },
          "TELEGRAM": {
            "PLACEHOLDER": "Add Telegram"
          },
          "TIKTOK": {
            "PLACEHOLDER": "Add TikTok"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "הוסף LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "הוסף טוויטר"
          }
        }
      },
      "DELETE_CONTACT": {
        "MESSAGE": "פעולה זו היא קבועה ובלתי הפיכה.",
        "BUTTON": "מחק עכשיו"
      }
    },
    "DETAILS": {
      "CREATED_AT": "נוצר ב-{date}",
      "LAST_ACTIVITY": "פעיל אחרון {date}",
      "DELETE_CONTACT_DESCRIPTION": "מחק לצמיתות את איש הקשר הזה. פעולה זו היא בלתי הפיכה",
      "DELETE_CONTACT": "מחק איש קשר",
      "DELETE_DIALOG": {
        "TITLE": "אשר מחיקה",
        "DESCRIPTION": "האם אתה בטוח שברצונך למחוק איש קשר זה?",
        "CONFIRM": "כן, מחק",
        "API": {
          "SUCCESS_MESSAGE": "איש הקשר נמחק בהצלחה",
          "ERROR_MESSAGE": "לא ניתן היה למחוק איש קשר. בבקשה נסה שוב מאוחר יותר."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "לא ניתן להעלות תמונה. אנא נסה שוב מאוחר יותר.",
          "SUCCESS_MESSAGE": "תמונה הועלתה בהצלחה"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "האוואטר נמחק בהצלחה",
          "ERROR_MESSAGE": "לא ניתן למחוק תמונה. אנא נסה שוב מאוחר יותר."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "מאפיינים",
        "HISTORY": "היסטוריה",
        "NOTES": "הערות",
        "MERGE": "מזג"
      },
      "HISTORY": {
        "EMPTY_STATE": "לא קיימות שיחות קודמות המשויכות לאיש קשר זה"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "חפש תכונות",
        "UNUSED_ATTRIBUTES": "{count} תכונה בשימוש | {count} תכונות שלא בשימוש",
        "EMPTY_STATE": "אין תכונות מותאמות אישית של איש קשר זמינות בחשבון זה. באפשרותך ליצור תכונה מותאמת אישית בהגדרות.",
        "YES": "כן",
        "NO": "לא",
        "TRIGGER": {
          "SELECT": "בחר ערך",
          "INPUT": "הזן ערך"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "מספר לא חוקי",
          "REQUIRED": "נדרש ערך חוקי",
          "INVALID_INPUT": "קלט לא חוקי",
          "INVALID_URL": "כתובת אתר לא חוקית",
          "INVALID_DATE": "תאריך לא חוקי"
        },
        "NO_ATTRIBUTES": "לא נמצאו מאפיינים",
        "API": {
          "SUCCESS_MESSAGE": "המאפיין עודכן בהצלחה",
          "DELETE_SUCCESS_MESSAGE": "המאפיין נמחק בהצלחה",
          "UPDATE_ERROR": "לא ניתן לעדכן את המאפיין. בבקשה נסה שוב מאוחר יותר",
          "DELETE_ERROR": "לא ניתן למחוק מאפיין. בבקשה נסה שוב מאוחר יותר"
        }
      },
      "MERGE": {
        "TITLE": "מזג אנשי קשר",
        "DESCRIPTION": "Combine two profiles into one, including all attributes and conversations. In case of conflict, the primary contact’s attributes will take precedence.",
        "PRIMARY": "איש קשר ראשי",
        "PRIMARY_HELP_LABEL": "לשמירה",
        "PRIMARY_REQUIRED_ERROR": "אנא בחר איש קשר למיזוג לפני שתמשיך",
        "PARENT": "למיזוג",
        "PARENT_HELP_LABEL": "להימחק",
        "EMPTY_STATE": "לא נמצאו אנשי קשר",
        "PLACEHOLDER": "חפש איש קשר ראשי",
        "SEARCH_PLACEHOLDER": "חפש איש קשר",
        "SEARCH_ERROR_MESSAGE": "לא ניתן לחפש אנשי קשר. אנא נסה שוב מאוחר יותר.",
        "SUCCESS_MESSAGE": "איש הקשר מוזג בהצלחה",
        "ERROR_MESSAGE": "לא ניתן למזג אנשי קשר, נסה שוב!",
        "IS_SEARCHING": "מחפש...",
        "BUTTONS": {
          "CANCEL": "ביטול",
          "CONFIRM": "מזג אנשי קשר"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "הוסף הערה",
        "WROTE": "נכתב",
        "YOU": "אתה",
        "SAVE": "שמור הערה",
        "ADD_NOTE": "הוסף הערת איש קשר",
        "EXPAND": "הרחב",
        "COLLAPSE": "כווץ",
        "NO_NOTES": "אין הערות, תוכל להוסיף הערות מדף פרטי איש הקשר.",
        "EMPTY_STATE": "אין הערות המשויכות לאיש קשר זה. תוכל להוסיף הערה על ידי הקלדה בתיבה שלמעלה.",
        "CONVERSATION_EMPTY_STATE": "אין עדיין הערות. השתמש בלחצן 'הוסף הערה' כדי ליצור אחת."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "לא נמצאו אנשי קשר בחשבון זה",
      "SUBTITLE": "התחל להוסיף אנשי קשר חדשים על ידי לחיצה על הכפתור למטה",
      "BUTTON_LABEL": "הוסף איש קשר",
      "SEARCH_EMPTY_STATE_TITLE": "אין אנשי קשר שתואמים לחיפוש שלך 🔍",
      "LIST_EMPTY_STATE_TITLE": "No contacts available in this view 📋",
      "ACTIVE_EMPTY_STATE_TITLE": "No contacts are active at the moment 🌙"
    },
    "LOAD_MORE": "טען עוד"
  },
  "CONTACTS_BULK_ACTIONS": {
    "ASSIGN_LABELS": "הקצה תוויות",
    "REMOVE_LABELS": "Remove Labels",
    "ASSIGN_LABELS_SUCCESS": "תוויות שוייכו בהצלחה.",
    "ASSIGN_LABELS_FAILED": "ההקצאה של התוויות נכשלה",
    "REMOVE_LABELS_SUCCESS": "Labels removed successfully.",
    "REMOVE_LABELS_FAILED": "Failed to remove labels",
    "DESCRIPTION": "בחר את התוויות שברצונך להוסיף לאנשי הקשר שנבחרו.",
    "NO_LABELS_FOUND": "אין עדיין תוויות זמינות.",
    "SELECTED_COUNT": "{count} נבחרו",
    "CLEAR_SELECTION": "נקה בחירה",
    "SELECT_ALL": "בחר הכל ({count})",
    "DELETE_CONTACTS": "מחק",
    "DELETE_SUCCESS": "אנשי קשר נמחקו בהצלחה.",
    "DELETE_FAILED": "מחיקת אנשי הקשר נכשלה.",
    "DELETE_DIALOG": {
      "TITLE": "מחק אנשי קשר שנבחרו",
      "SINGULAR_TITLE": "מחק איש קשר שנבחר",
      "DESCRIPTION": "פעולה זו תמחק לצמיתות {count} אנשי קשר שנבחרו. לא ניתן לבטל פעולה זו.",
      "SINGULAR_DESCRIPTION": "פעולה זו תמחק לצמיתות את איש הקשר שנבחר. לא ניתן לבטל פעולה זו.",
      "CONFIRM_MULTIPLE": "מחק אנשי קשר",
      "CONFIRM_SINGLE": "מחק איש קשר"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn’t complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "צפה",
      "SUCCESS_MESSAGE": "ההודעה נשלחה בהצלחה!",
      "ERROR_MESSAGE": "אירעה שגיאה ביצירת השיחה. אנא נסה שוב מאוחר יותר.",
      "NO_INBOX_ALERT": "אין תיבות דואר נכנס זמינות כדי להתחיל שיחה עם איש קשר זה.",
      "CONTACT_SELECTOR": {
        "LABEL": "אל:",
        "TAG_INPUT_PLACEHOLDER": "Enter at least 2 characters to search by name, email, or phone number",
        "CONTACT_CREATING": "יוצר איש קשר..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "דרך:",
        "BUTTON": "הצג תיבות דואר נכנס"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "נושא :",
        "SUBJECT_PLACEHOLDER": "הזן את נושא הדוא\"ל שלך כאן",
        "CC_LABEL": "עותק:",
        "CC_PLACEHOLDER": "Enter at least 2 characters to search by email",
        "BCC_LABEL": "עותק מוסתר:",
        "BCC_PLACEHOLDER": "Enter at least 2 characters to search by email",
        "BCC_BUTTON": "עותק מוסתר"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "כתוב את הודעתך כאן..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "בחר תבנית",
        "SEARCH_PLACEHOLDER": "חפש תבניות",
        "EMPTY_STATE": "לא נמצאו תבניות",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "תבנית WhatsApp: {templateName}",
          "VARIABLES": "משתנים",
          "BACK": "חזור",
          "SEND_MESSAGE": "שלח הודעה"
        }
      },
      "TWILIO_OPTIONS": {
        "LABEL": "בחר תבנית",
        "SEARCH_PLACEHOLDER": "חפש תבניות",
        "EMPTY_STATE": "לא נמצאו תבניות",
        "TEMPLATE_PARSER": {
          "BACK": "חזור",
          "SEND_MESSAGE": "שלח הודעה"
        }
      },
      "ACTION_BUTTONS": {
        "DISCARD": "בטל",
        "SEND": "שלח ({keyCode})"
      }
    }
  }
}
